import { CUSTOM_ELEMENTS_SCHEMA, NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import {  RouterModule, Routes } from '@angular/router';
import { DataTablesModule } from 'angular-datatables';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { UserManagementComponent } from './user-management/user-management.component';
import { CreateUserModalComponent } from './create-user-modal/create-user-modal.component';

import { UserMasterService } from './../../services/user-master.service';
import { ConfirmationModalComponent } from './confirmation-modal/confirmation-modal.component';
import { EditUserModalComponent } from './edit-user-modal/edit-user-modal.component';
import { CopyUserToCompaniesModalComponent } from './copy-user-to-companies-modal/copy-user-to-companies-modal.component';
import { CompanyMasterService } from '../../services/companymaster.service';

import { SharedModule } from '../../shared/shared.module';

import { ImageCropperModule } from 'ngx-img-cropper';
import { AuthGuard } from '../../authGuard/auth.guard';
import { RouteGuard } from '../../routeGaurd/route.guard';
import { CommaSeperatedNumber } from '../../helpers/CommaSeperatedNumber';
import { CommonFunction } from '../../helpers/commonFunction';
import { PasswordConfirmationModalComponent } from './password-confirmation-modal/password-confirmation-modal.component';
import { SharerService } from 'src/app/services/sharer.service';
import { HttpService } from 'src/app/services/http/http.service';
import { TaskService } from 'src/app/services/task.service';
export const routes: Routes = [
  {
    path: 'userMaster/userManagement',
    component: UserManagementComponent,
    canActivate: [AuthGuard, RouteGuard],
    outlet: 'structure-outlet',
  },
];

@NgModule({
  imports: [
    CommonModule,
    RouterModule.forChild(routes),
    DataTablesModule,
    NgbModule,
    ReactiveFormsModule,
    FormsModule,
    SharedModule,
    ImageCropperModule,
    NgSelectModule,
  ],
  declarations: [
    UserManagementComponent,
    CreateUserModalComponent,
    ConfirmationModalComponent,
    EditUserModalComponent,
    CopyUserToCompaniesModalComponent,
    CommaSeperatedNumber,
    PasswordConfirmationModalComponent,
  ],
  providers: [UserMasterService, CommonFunction, CompanyMasterService,HttpService,TaskService,SharerService],
  entryComponents: [
    CreateUserModalComponent,
    ConfirmationModalComponent,
    EditUserModalComponent,
    CopyUserToCompaniesModalComponent,
    PasswordConfirmationModalComponent,
  ],
  exports: [
    NgSelectModule
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA,
    NO_ERRORS_SCHEMA
  ]
})
export class UserMasterModule {}
